<template>
  <div id="bagWordRoot" @click="hideBagWordPage()">
    <div id="bagWordContainer" style="width: 70%;background: #fff;z-index: 2255;border-radius: 10px;display: flex;flex-direction: column;justify-content: center;">
      <div id="bagWordTitleParent" style="font-size:small;color:black;display:flex;justify-content:center;align-items:center;margin-top:10px;">礼包码</div>
      <div id="bagWordMessageTagParent" style="display:flex;justify-content:center;align-items:center;margin-top:10px;font-size: large;color:#FA4723;font-weight: bolder;">
        {{bagWord}}
      </div>
      <div style="display:flex;justify-content:center; align-items:center;margin-top: 10px;margin-bottom: 10px;">
        <button @click="copyBagWord()">复 制</button>
      </div>
    </div>
  </div>
 </template>
 
 <script>
  export default {
    props:{
      bagWord: "",
    },
    data () {
      return {}
    },
    components: {
    },
    methods:{
      // 隐藏提示页面
      hideBagWordPage(){
        event.stopPropagation();
        this.$emit('hideBagWordPage')
      },
      copyBagWord(){
        event.stopPropagation();
        var obj = {"content":this.bagWord, "toastMsg": "礼包码复制成功"};
        this.sendToClient('copyClick?'+JSON.stringify(obj))
        this.$emit('hideBagWordPage')
      }
    }
  }
 </script>
 
 <style>
#bagWordRoot{
    /* display: none; */
  width: 100%;
  height: 70vh;
  position: absolute;
  background: rgba(51,51,51,0.5);
  z-index: 2233;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0%;
  left: 0%;
}

#bagWordRoot button {
  background: -webkit-linear-gradient(left, #FF610F, #F6A026);
  border-radius: 20px;
  padding-top: 3px;
  padding-bottom: 3px;
  height: 30px;
  width: 70%;
  color: white;
  font-size: small;
  border: none;
}

</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/bag/ShowBagWord.vue